import { CHARTS_TYPE_ENUM } from "../../../../enums/charts-type.enum";
import METRICS_ENUM, {
  ACTIONS_DRIVING_DIRECTIONS,
  ACTIONS_PHONE,
  ACTIONS_WEBSITE,
  QUERIES_CHAIN,
  QUERIES_DIRECT,
  QUERIES_INDIRECT,
  VIEWS_MAPS,
  VIEWS_SEARCH
} from "@/enums/gmbMetrics.enum.js";
import { i18n } from "@/main";
import { APP_COLORS } from "@/config/app-colors";
import { MakeGMBChartsBase } from "./make-gmb-charts-base";

export class MakeGMBCharts extends MakeGMBChartsBase {
  constructor() {
    super();
    this._colors = {
      violet: APP_COLORS.PRIMARY,
      violetLight: APP_COLORS.PRIMARY_LIGHT,
      lime: APP_COLORS.ACCENT
    };
    this._chartsConfig = {
      directDiscoveryBranded: {
        type: CHARTS_TYPE_ENUM.DOUGHNUT,
        colors: [
          this._colors.violet,
          this._colors.violetLight,
          this._colors.lime
        ],
        metrics: [QUERIES_DIRECT, QUERIES_INDIRECT, QUERIES_CHAIN],
        labels: [
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.direct"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.direct"
            )
          },
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.indirect"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.indirect"
            )
          },
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.branded"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.branded"
            )
          }
        ]
      },
      searches: {
        type: CHARTS_TYPE_ENUM.BAR,
        colors: [
          this._colors.violet,
          this._colors.violetLight,
          this._colors.lime
        ],
        metrics: [QUERIES_DIRECT, QUERIES_INDIRECT, QUERIES_CHAIN],
        labels: [
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.direct"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.direct"
            )
          },
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.indirect"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.indirect"
            )
          },
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.text.branded"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.directDiscoveryBranded.label.tooltip.branded"
            )
          }
        ]
      },
      searchMaps: {
        type: CHARTS_TYPE_ENUM.DOUGHNUT,
        labels: [
          i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.search"
          ),
          i18n.t(
            "message.analytics.businessAddresses.chart.searchMaps.label.maps"
          )
        ],
        colors: [this._colors.violet, this._colors.lime],
        metrics: [VIEWS_SEARCH, VIEWS_MAPS]
      },
      maps: {
        type: CHARTS_TYPE_ENUM.BAR,
        labels: [
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.search"
            )
          },
          {
            text: i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            ),
            tooltip: i18n.t(
              "message.analytics.businessAddresses.chart.searchMaps.label.maps"
            )
          }
        ],
        colors: [this._colors.violet, this._colors.lime],
        metrics: [VIEWS_SEARCH, VIEWS_MAPS]
      },
      clicks: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_WEBSITE]
      },
      directions: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_DRIVING_DIRECTIONS]
      },
      calls: {
        type: CHARTS_TYPE_ENUM.LINE,
        colors: [this._colors.violet],
        metrics: [ACTIONS_PHONE]
      }
    };
    this._gmbData = null;
    this.charts = {};
  }
}
